
export const debugLog = (...any: any) => {
    if (location.host.includes('localhost')) {
        console.log(...any)
    }
}
